<template>
    <v-card :loading="loading" min-height="500">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-card-title>
            <v-layout row wrap>
                <v-col cols="12">
                    {{ title }}
                </v-col>
                <v-col md="5" sm="12">
                    <period-selector v-model="period" :button-class="['mt-3']"></period-selector>
                </v-col>
                <v-col md="7" sm="12">
                    <user-selector v-model="filterByUser"></user-selector>
                </v-col>
            </v-layout>
            <v-dialog
                v-model="dialog"
                max-width="500px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="primary"
                        dark
                        class="ml-2"
                        v-bind="attrs"
                        v-on="on"
                    >
                        Adaugare
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-autocomplete
                                        :items="users"
                                        :item-text="(item) => `${item.name} (${item.email})`"
                                        item-value="id"
                                        v-model="form.user_id"
                                        :error-messages="errorMessages('user_id')"
                                        :class="{ 'error--text': hasErrors('user_id') }"
                                        label="Personal"
                                        prepend-icon="mdi-account"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col v-if="dialogVacationData.show" cols="12" sm="12">
                                    <v-alert
                                        dense
                                        :type="dialogVacationData.loading ? 'info' : 'success'"
                                    >
                                        <template v-if="dialogVacationData.loading ">
                                            <v-progress-circular
                                                indeterminate
                                                color="primary"
                                            ></v-progress-circular>
                                            Datele sunt in curs de incarcare...
                                        </template>
                                        <template v-else>
                                            <span>Anul curent reprezinta urmatoarea situatie:<br/></span>
                                            <span v-for="itemKey in Object.keys(dialogVacationData.data)" :key="itemKey">{{ _.get(holidayTypes.find(type => type.id === itemKey), 'text', '?') }}: {{ dialogVacationData.data[itemKey] }}<br/></span>
                                        </template>
                                    </v-alert>
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-select
                                        v-model="form.type"
                                        :items="holidayTypes"
                                        item-value="id"
                                        item-text="text"
                                        placeholder="Tip concediu"
                                        prepend-icon="mdi-format-list-checks"
                                    />
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-menu
                                        ref="vacationDateMenu"
                                        v-model="vacationDateMenu"
                                        :close-on-content-click="false"
                                        :return-value.sync="vacationPeriod"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="form.vacation_start"
                                                :error-messages="errorMessages('vacation_start')"
                                                :class="{ 'error--text': hasErrors('vacation_start') }"
                                                label="Inceput concediu"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                            <v-text-field
                                                v-model="form.vacation_end"
                                                :error-messages="errorMessages('vacation_end')"
                                                :class="{ 'error--text': hasErrors('vacation_end') }"
                                                label="Sfarsit concediu"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="vacationPeriod"
                                            range
                                            no-title
                                            scrollable
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="vacationDateMenu = false"
                                            >
                                                Renuntare
                                            </v-btn>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="$refs.vacationDateMenu.save(vacationPeriod)"
                                            >
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-textarea
                                        v-model="form.remarks"
                                        :error-messages="errorMessages('remarks')"
                                        :class="{ 'error--text': hasErrors('remarks') }"
                                        label="Observatii"
                                        prepend-icon="mdi-message"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="close"
                        >
                            Renuntare
                        </v-btn>
                        <v-btn
                            color="blue darken-1"
                            text
                            :loading="form.busy"
                            @click="save"
                        >
                            Salveaza
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-btn dark color="primary" class="ml-2" @click="exportPDF">
                Export
            </v-btn>
            <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="headline">Sunteti sigur ca doriti stergerea intrarii?</v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeDelete">Anulare</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteItemConfirm">Confirmare</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            class="elevation-1"
        >
            <template v-slot:item.vacation_start="{ item }">
                {{ new Date(item.vacation_start) | dateWithDay }}
            </template>
            <template v-slot:item.vacation_end="{ item }">
                {{ new Date(item.vacation_end) | dateWithDay }}
            </template>
            <template v-slot:item.user_id="{ item }">
                {{ item.employee.name }}
            </template>
            <template v-slot:item.type="{ item }">
                {{ item.friendlyType }}
            </template>
            <template v-slot:item.created_at="{ item }">
                {{ new Date(item.created_at) | datetime }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn
                    v-if="canUpdate(item)"
                    outlined
                    x-small
                    fab
                    class="mr-2"
                    color="primary"
                    @click="editItem(item)"
                >
                    <v-icon>
                        mdi-pencil
                    </v-icon>
                </v-btn>
                <v-btn
                    v-if="canDelete(item)"
                    outlined
                    x-small
                    fab
                    class="mr-2"
                    color="error"
                    @click="deleteItem(item)"
                >
                    <v-icon>
                        mdi-delete
                    </v-icon>
                </v-btn>
            </template>
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>
import SmartTable from "Components/SmartTable";
import PeriodSelector from "Components/common/PeriodSelector";
import UserSelector from "Components/common/UserSelector";
import ACL from "Mixins/acl";
import validationError from "Mixins/validation-error";
import {Form} from "vform";
export default {
    mixins: [ACL, validationError],
    extends: SmartTable,
    components: {
        PeriodSelector,
        UserSelector
    },
    data: () => ({
        title: 'Planificare concediu personal',
        dialog: false,
        loading: true,
        headers: [
            { text: 'Personal', value: 'user_id' },
            { text: 'Tip', value: 'type' },
            { text: 'Inceput concediu', value: 'vacation_start' },
            { text: 'Sfarsit concediu', value: 'vacation_end' },
            { text: 'Total zile', value: 'total' },
            { text: 'Observatii', value: 'remarks' },
            { text: 'Data crearii', value: 'created_at' },
            { text: 'Actiuni', value: 'actions', sortable: false },
        ],
        items: [],
        options: {
            sortBy: ['created_at'],
            sortDesc: [true]
        },
        editedIndex: -1,
        form: new Form({
            id: null,
            user_id: null,
            vacation_start: null,
            vacation_end: null,
            total: null,
            type: null,
            remarks: null,
            created_at: null
        }),
        defaultItem: {
            id: null,
            user_id: null,
            vacation_start: null,
            vacation_end: null,
            total: null,
            type: null,
            remarks: null,
            created_at: null
        },
        period: [window.moment().subtract(1, 'month').toISOString(), window.moment().toISOString()],
        filterByUser: null,
        vacationDateMenu: false,
        dialogVacationData: {
            show: false,
            loading: false,
            data: {}
        }
    }),

    computed: {
        formTitle () {
            return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
        },
        users() {
            return this.Static.employees
        },
        vacationPeriod: {
            get() {
                let response = []
                if (!this._.isNil(this.form.vacation_start)) {
                    response.push(this.form.vacation_start)
                }
                if (!this._.isNil(this.form.vacation_end)) {
                    response.push(this.form.vacation_end)
                }
                return response
            },
            set(val) {
                if (val instanceof Array) {
                    this.form.vacation_start = val[0]
                    this.form.vacation_end = val[1]
                }
            }
        },
        holidayTypes() {
            return (new this.$db.Holiday).types
        }
    },

    watch: {
        dialog (val) {
            val || this.close()
        },
        period: {
            async handler(val) {
                await this.initialize()
            }
        },
        filterByUser: {
            async handler(val) {
                await this.initialize()
            }
        },
        'form.user_id': {
            handler (val) {
                if (val && parseInt(val) > 0) {
                    this.dialogVacationData.loading = true
                    this.dialogVacationData.show = true
                    this.$db.Employee
                        .append('holiday_summary')
                        .find(val)
                        .then(({data}) => {
                            this.dialogVacationData.data = data?.holiday_summary
                        })
                        .finally(() => {
                            this.dialogVacationData.loading = false
                        })
                }
            }
        }
    },

    async created () {
        await this.initialize()
    },

    methods: {
        async buildQuery() {
            var query = this.$db.Holiday
                .orderBy(this.orderBy)
                .include('employee')
                .page(this.options.page)
                .limit(this.options.itemsPerPage)
            if(this.period instanceof Array && this.period.length === 2) {
                query = query.where('between', [window.moment(this.period[0]).format('YYYY-MM-DD'), window.moment(this.period[1]).format('YYYY-MM-DD')].join(','))
            }
            if(!this._.isNil(this.filterByUser)) query = query.where('user_id', this.filterByUser.join(','))
            return query
        },
        async initialize () {
            this.loading = true
            let query = await this.buildQuery()
            let { data, meta } = await query.get().then((response) => {
                response.data = response.data.map(item => {
                    item.start = this.$moment(item.start, 'HH:mm:ss').format('HH:mm')
                    if (!this._.isNil(item.end)) {
                        item.end = this.$moment(item.end, 'HH:mm:ss').format('HH:mm')
                    }
                    return item
                })
                return response
            })
            this.items = data
            this.meta = meta
            this.loading = false
        },
        async exportPDF () {
            let workstation = this.$store.getters['workstation/getWorkstationId'] || 1
            let query = await this.buildQuery()
            let holidaysUri = query
                .custom('holidays/export')
                .page(1)
                .limit(10000)
                ._builder
                .query()
            this.loading = true
            return window.axios.get(`${route('holidays.export', {workstation})}${holidaysUri}`, {
                responseType: 'blob'
            }).then((response) => {
                const contentDisposition = this._.get(response, 'headers.content-disposition')
                const filename = contentDisposition.split("filename=")[1];
                const downloadUrl = window.URL.createObjectURL(new Blob([response?.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', filename); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
            }).catch((err) => {
                console.error(err)
            }).finally(() => {
                this.loading = false
            })
        },

        editItem (item) {
            this.editedIndex = this.items.indexOf(item)
            this.form = new Form(Object.assign({}, item))
            this.dialog = true
        },

        close () {
            this.dialog = false
            this.$nextTick(() => {
                this.form = new Form(Object.assign({}, this.defaultItem))
                this.editedIndex = -1
            })
        },
        async save() {
            let self = this;
            this.$validator.validateAll().then(async result => {
                if (result) {
                    // eslint-disable-next-line
                    await self.createOrUpdate();
                } else {
                    this.showError()
                }
            });
        },
        async createOrUpdate() {
            let self = this;
            self.form.busy = true;

            var model = new this.$db.Holiday(self.form);
            if (this.id) {
                model.id = this.id
            }

            model.save()
                .then(response => {
                    self.$validator.reset();
                    self.showSuccess();
                    self.close()
                    self.initialize()
                })
                .catch(errors => {
                    self.form.errors.set(this.form.extractErrors(errors.response))
                    self.showError(errors.response?.data?.message)
                }).finally(() => {
                    self.form.busy = false;
                });
        },
        canDelete(item) {
            return this.hasAnyRole(['admin'])
        },
        async deleteItemConfirm () {
            let item = this.items[this.editedIndex]
            if(item instanceof this.$db.Holiday) {
                await item.delete().catch((err) => {
                    this.showError(err?.response?.data?.error)
                    throw err
                })
            } else {
                console.warn('Here comes the headache...')
            }
            this.dialogDelete = false
            await this.initialize()
        },

    },
    filters: {
        toHHMMSS (value) {
            var sec_num = parseInt(value, 10); // don't forget the second param
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            if (hours > 0) {
                if (minutes > 0) {
                    return `${hours} ${parseFloat(hours) > 1 ? 'ore' : 'ora'} si ${minutes} ${parseFloat(minutes) > 1 ? 'minute' : 'minut'}`;
                } else {
                    return `${hours} ${parseFloat(hours) > 1 ? 'ore' : 'ora'}`;
                }
            } else {
                return `${minutes} ${parseFloat(minutes) > 1 ? 'minute' : 'minut'}`;
            }
        }
    }
}
</script>
